import React, { useState, useEffect } from 'react';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import GlobalTooltip from 'components/GlobalTooltip';

function SummarizeFile(props) {
  const { rowData } = props;
  const { handleShowSummaryModal, handleOpenConfigureSummaryModal, summaryGenerationStatus } = useFileManagerContext();
  const [status, setStatus] = useState('default');

  const getSummaryStatus = (currentRowData = null) => {
    const dataToCheck = currentRowData || rowData;
    const fileIdKey = dataToCheck?.file_id || dataToCheck?.object_id || dataToCheck?.sk?.split('#')?.[1];

    const statusData = summaryGenerationStatus[fileIdKey];
    const isError = statusData?.error_status === true;

    if (statusData?.summary_generation_status === 'in_progress') {
      return 'processing';
    } else if (statusData?.summary_generation_status === 'failed' || isError) {
      return 'failed';
    } else if (statusData?.summary_generation_status === 'success') {
      return 'ready';
    }

    if (statusData?.summary_status) {
      if (statusData?.summary_status === 'processing') {
        return 'processing';
      }
      if (statusData?.summary_status === 'ready') {
        return 'ready';
      }
      if (statusData?.summary_status === 'failed') {
        return 'failed';
      }
    }

    if (dataToCheck?.summary?.summary_generation_status && typeof dataToCheck?.summary?.summary_generation_status === 'string') {
      let normalizedStatus = dataToCheck?.summary?.summary_generation_status.toLowerCase();
      if (normalizedStatus === 'in progress') {
        normalizedStatus = 'in_progress';
      }

      const isError = dataToCheck?.summary?.isError === true;

      if (normalizedStatus === 'in_progress') {
        return 'processing';
      } else if (normalizedStatus === 'failed' || isError) {
        return 'failed';
      } else if (normalizedStatus === 'success') {
        return 'ready';
      }
    }

    if (dataToCheck?.summary_versions && Array.isArray(dataToCheck.summary_versions) && dataToCheck.summary_versions.length > 0) {
      const latestRowSummary = dataToCheck.summary_versions[dataToCheck.summary_versions.length - 1];
      if (latestRowSummary?.error_status === false && latestRowSummary?.s3_path) {
        return 'ready';
      } else if (latestRowSummary?.error_status === true) {
        return 'failed';
      } else {
        return 'processing';
      }
    }

    return 'default';
  };

  useEffect(() => {
    const currentStatus = getSummaryStatus(rowData);
    setStatus(currentStatus);
  }, [
    rowData?.file_id,
    rowData?.summary_versions,
    rowData?.summary?.summary_generation_status,
    rowData?.summary?.s3_path,
    rowData?.summary?.isError,
    summaryGenerationStatus,
  ]);

  const handleClick = () => {
    if (status === 'processing') {
      return;
    }
    if (status === 'failed') {
      handleOpenConfigureSummaryModal(rowData);
      return;
    }
    if (status === 'ready') {
      handleShowSummaryModal(rowData);
    } else {
      handleOpenConfigureSummaryModal(rowData);
    }
  };

  const getStatusConfig = () => {
    switch (status) {
      case 'processing':
        return {
          icon: 'pi pi-spin pi-spinner',
          iconColor: 'var(--orangy)',
          tooltip: 'Summary is being processed',
        };
      case 'ready':
        return {
          icon: 'pi pi-check-circle',
          iconColor: 'var(--success)',
          tooltip: 'Summary is ready',
        };
      case 'failed':
        return {
          icon: 'pi pi-exclamation-triangle',
          iconColor: 'var(--error-text)',
          tooltip: 'Summary generation failed',
        };
      default:
        return {
          icon: 'pi pi-file',
          iconColor: 'var(--primary-main)',
          tooltip: 'Summarize file',
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span role="button" onClick={handleClick}>
      <GlobalTooltip tooltip={config.tooltip} position="top">
        <i className={`${config.icon} me-3`} style={{ fontSize: '14px', color: config.iconColor }} />
      </GlobalTooltip>
    </span>
  );
}

export default SummarizeFile;
